<template>
    <div style="display:flex; flex-direction:column; justify-content:center; align-items:center;">
      <Header></Header>
      <HeaderSec Title="用友U9系列-经典部署方案：Bluesolution-U9" Desc="" :BreadcrumbList="BreadcrumbList"></HeaderSec>
      <Row style="padding:20px;" gutter="24" class="list">
          <Col :xs="22" :sm="22" :md="22" :lg="22" :xl="18" :xxl="18">
            <Card style="width:100%" :bordered="false" :dis-hover="true" :shadow="true">
              <template #title>
                <Title :level="5">
                  <Icon type="ios-film-outline"></Icon>
                  方案简介： Bluesolution-U9
                </Title>
              </template>
              <div style="display: flex; flex-direction:row; justify-content:space-between;">
                <Typography>
                  <Paragraph>
                    <Title :level="6">物理层云化+应用层集群化，支持横向扩容，全面支持性能突发，支持故障转移，提供高阶的系统可用性</Title>
                  </Paragraph>
                  <Paragraph>
                    <ul>
                        <li>应用采用分离部署结构，应用和数据库进行分离单独部署，按各种的特性以支持灵活的部署方式</li>
                        <li>WebServer和AppServer通过网络负载（Haproxy解决方案）方案提升系统性能和并发用户支持能力</li>
                        <li>DBServer通过服务器群集提供故障转移和故障恢复能力</li>
                        <li>由1台以上云主机作为U9业务应用服务器（含Web服务器）</li>
                        <li>由1台云主机作为U9测试服务器</li>
                        <li>由1台以上高频裸金属服务器作为U9数据库服务器部署（含数据库服务器和报表服务器）</li>
                        <li>由1台以上云主机作为haproxy的负载均衡</li>
                        <li>由1台云主机作为数据库降级运行点，用于共享文件夹进行数据库备份和灾难时进行数据库快速拉起容灾</li>
                    </ul>
                  </Paragraph>
                </Typography>
                <Image src="https://www.bluehci.com/images001/solution001.png" fit="contain" width="270px" height="161px" alt="contain" />
              </div>
            </Card>
            <Card style="width:100%" :bordered="false" :dis-hover="true" :shadow="true">
              <template #title>
                <Title :level="5">
                    <Icon type="ios-school-outline" />
                  集群拓扑
                </Title>
              </template>
              <div style="display: flex; flex-direction:row; justify-content:space-between;">
                <Image src="https://www.bluehci.com/images001/Bluesolution-U9-001.png" fit="contain" width="980px" height="552px" alt="contain" />
                <Paragraph>
                    <ul>
                        <li>最小两个物理服务器节点即可部署</li>
                        <li>支持云网混合云形态，可以通过公有云无缝穿透访问</li>
                        <li>采用虚拟化与裸金属混合形态，兼顾性能与效率</li>
                        <li>少量投入，大大效果，极致性价比</li>
                    </ul>
                  </Paragraph>
              </div>
            </Card>
            <Card style="width:100%" :bordered="false" :dis-hover="true" :shadow="true">
              <template #title>
                <Title :level="5">
                    <Icon type="ios-school-outline" />
                  推荐网络拓扑
                </Title>
              </template>
              <div style="display: flex; flex-direction:row; justify-content:space-between;">
                <Image src="https://www.bluehci.com/images001/Bluesolution-U9-002.png" fit="contain" width="980px" height="552px" alt="contain" />
                <Paragraph>
                    <ul>
                        <li>经典层次架构，高扩展能力，高安全能力与灵活性</li>
                        <li>功能齐全，全面适用各种网络布局场景</li>
                        <li>高度伸缩能力，全面适用各种大小规模</li>
                        <li>稳定可靠，应用广泛</li>
                    </ul>
                  </Paragraph>
              </div>
            </Card>
            <Card style="width:100%" :bordered="false" :dis-hover="true" :shadow="true">
              <template #title>
                <Title :level="5">
                  <Icon type="ios-medal-outline" />
                  推荐物料清单
                </Title>
              </template>
              <Table :columns="columns" :data="data">
                <template #link="{ row }">
                    <router-link :to="row.link">{{ row.link }}</router-link>
                </template>
              </Table>
            </Card>
          </Col>
          <Col :xs="0" :sm="0" :md="0" :lg="0" :xl="6" :xxl="6">
            <BlueSolutionSideList></BlueSolutionSideList>
          </Col>
      </Row>
    </div>
</template>

<script>
import BlueSolutionSideList from '@/components/BlueSolution-sideList.vue'
import Header from '@/components/Header.vue'
import HeaderSec from '@/components/HeaderSec.vue'
export default {
  name: 'BlueSolution-U9',
  components: {
    BlueSolutionSideList,
    Header,
    HeaderSec,
  },
  setup() {
  },
  data(){
    return {
        BreadcrumbList: [
            {
                title: '首页',
                to: '/'
            },
            {
                title: '数字化IT咨询与运维',
                to: '/Bluesolution'
            },
            {
                title: 'BlueSolution-U9'
            }
        ],
        columns: [
            {
                title: '物料项',
                key: 'key',
            },
            {
                title: '推荐',
                key: 'value'
            },
            {
                title: '物料链接',
                slot: 'link',
                width: 266,
            },
        ],
        data: [
            {
              key:"超融合集群服务器",
              value:"Blueiaas-LX5-HS302 一台以上，推荐双节点执行主备容灾模式，或者三节点执行集群容灾模式",
              link:"Blueiaas-LX5-HS302",
            },
            {
              key:"数据库服务器",
              value:"LX5-ML022 一台以上，推荐双节点执行故障转移容灾模式",
              link:"Blueiaas-LX5-ML022",
            },
            {
              key:"冷备服务器",
              value:"LX5-OS002 一台以上，使用NAS的能力进行冷备份",
              link:"Blueiaas-LX5-OS002",
            },
            {
              key:"BlueSolution-U9方案全生命周期服务",
              value:"蓝心数智官方数字化IT咨询与运维服务-等级二",
              link:"BlueSolution",
            },
        ],
    }
  },
  methods: {
    handleClick() {
      this.$Message.info('Welcome to View UI Plus Demo!')
    }
  }
}
</script>

<style lang="less" scoped>
.list{
  width: 90%;
}
@media (min-width: 1000px) {
  .list{
    width: 1600px;
  }
}
</style>
